
import Blc_LocationOne from "./Blc_LocationOne";

const Blc_Locations = (props)=>{

  const blcIndex = (index) =>{
    props.valIndex(index);
  }

    return(
        <>
        
     
          <Blc_LocationOne valIndex={blcIndex} navData = {props.navDataPh}/>
          
        </>
    )
}


export default Blc_Locations;